import { AspectRatioResolutions, ResolutionOption } from '../types';

// 为每种宽高比定义分辨率选项
export const resolutionOptions: AspectRatioResolutions = {
  // 1:1 - 正方形
  '1:1': [
    { id: '512x512', width: 512, height: 512, label: '512×512' },
    { id: '768x768', width: 768, height: 768, label: '768×768' },
    { id: '1024x1024', width: 1024, height: 1024, label: '1024×1024' },
    { id: '1280x1280', width: 1280, height: 1280, label: '1280×1280' }
  ],
  
  // 16:9 - 宽屏
  '16:9': [
    { id: '512x288', width: 512, height: 288, label: '512×288' },
    { id: '768x432', width: 768, height: 432, label: '768×432' },
    { id: '1024x576', width: 1024, height: 576, label: '1024×576' },
    { id: '1280x720', width: 1280, height: 720, label: '1280×720' }
  ],
  
  // 4:3 - 标准宽屏
  '4:3': [
    { id: '512x384', width: 512, height: 384, label: '512×384' },
    { id: '768x576', width: 768, height: 576, label: '768×576' },
    { id: '1024x768', width: 1024, height: 768, label: '1024×768' },
    { id: '1280x960', width: 1280, height: 960, label: '1280×960' }
  ],
  
  // 3:4 - 垂直标准
  '3:4': [
    { id: '384x512', width: 384, height: 512, label: '384×512' },
    { id: '576x768', width: 576, height: 768, label: '576×768' },
    { id: '768x1024', width: 768, height: 1024, label: '768×1024' },
    { id: '960x1280', width: 960, height: 1280, label: '960×1280' }
  ],
  
  // 9:16 - 垂直宽屏
  '9:16': [
    { id: '288x512', width: 288, height: 512, label: '288×512' },
    { id: '432x768', width: 432, height: 768, label: '432×768' },
    { id: '576x1024', width: 576, height: 1024, label: '576×1024' },
    { id: '720x1280', width: 720, height: 1280, label: '720×1280' }
  ]
};

// 获取特定宽高比的默认分辨率
export const getDefaultResolution = (aspectRatio: string): ResolutionOption => {
  const options = resolutionOptions[aspectRatio] || resolutionOptions['1:1'];
  // 默认使用第二个选项 (768x768 或对应的中等分辨率)
  return options[1];
};

// 根据ID获取分辨率选项
export const getResolutionById = (aspectRatio: string, resolutionId: string): ResolutionOption => {
  const options = resolutionOptions[aspectRatio] || resolutionOptions['1:1'];
  const resolution = options.find(option => option.id === resolutionId);
  return resolution || options[1]; // 默认返回第二个选项
};
